export enum Language {
  PT = 'pt',
  EN = 'en',
  ES = 'es'
}
